export const TOGGLE_MAP_VISIBILITY = 'TOGGLE_MAP_VISIBILITY';

export const showMap = () => ({
  type: TOGGLE_MAP_VISIBILITY,
  payload: true,
});

export const hideMap = () => ({
  type: TOGGLE_MAP_VISIBILITY,
  payload: false,
});
